"use strict";
const forceReflow = (node) => node && node.scrollTop;
export default forceReflow;
